import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { axiosRestInstance } from "../../../../common/axios";
import {
  PartnerEngagementConfigurationListType,
  PartnerEngagementCategoryListType,
} from "../../../slices/partner-program/engagement-configuration/Types";
import { partnerEngagementConfigurationSliceAction } from "../../../slices/partner-program/engagement-configuration";
import {
  getOverviewEventListing,
  partnerProgramEventSagaActionTypes,
  getPartnerPointsSummary,
  getPartnerPointsDraftSummary,
  getPartnerPoints,
} from "./saga-action";
import { partnerProgramEventConfigurationSliceAction } from "../../../slices/partner-program/calculator";

type eventListAPIResponseType = {
  success: boolean;
  message: string;
  url?: string;
  data: any;
};
const getAllEventListOverview = async (ID: number) => {
  let response = axiosRestInstance
    .get<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/events/getEvents/" + ID
    )
    .then((res) => res.data);
  return response;
};

const fetchPartnerPointsAPI = async (ID: number) => {
  let response = axiosRestInstance
    .get<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/points/getPartnerPoints/" + ID
    )
    .then((res) => res.data);
  return response;
};

const getPartnerPointsSummaryFN = async (ID: number) => {
  let response = axiosRestInstance
    .get<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/points/partnerPointsSummary/" + ID
    )
    .then((res) => res.data);
  return response;
};

const getPartnerPointsDraftSummaryFN = async (ID: number) => {
  let response = axiosRestInstance
    .get<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/points/partnerPointsDraftSummary/" + ID
    )
    .then((res) => res.data);
  return response;
};

const createEvent = async (eventDeatils: any) => {
  let response = axiosRestInstance
    .post<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/events/createEvent",
      eventDeatils
    )
    .then((res) => res.data);
  return response;
};

const updateEvent = async (eventDeatils: any) => {
  let id = null;
  if (eventDeatils instanceof FormData) {
    id = eventDeatils.get("ID");
    console.log("id", id);
  } else {
    id = eventDeatils.ID;
  }

  let response = axiosRestInstance
    .put<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/events/updateEvent/" + id,
      eventDeatils
    )
    .then((res) => res.data);
  return response;
};

const submitPartnerPoints = async (eventDeatils: any) => {
  let response = axiosRestInstance
    .post<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/points/partnerPoints",
      eventDeatils
    )
    .then((res) => res.data);
  return response;
};

const updatePartnerPointsAPI = async (id: number, body: any) => {
  let response = axiosRestInstance
    .put<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/points/partnerPoints/" + id,
      body
    )
    .then((res) => res.data);
  return response;
};

const deletePartnerPointsAPI = async (assessmentId: number) => {
  let response = axiosRestInstance
    .delete<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/points/partnerPoints/delete/" + assessmentId
    )
    .then((res) => res.data);
  return response;
};

const getFileUrlFn = async (fileName: any, type: any) => {
  let response = axiosRestInstance
    .get<AxiosResponse<eventListAPIResponseType>>(
      "/partner-program/events/getFileUrl?fileKey=" + fileName + "&type=" + type
    )
    .then((res) => res.data);
  return response;
};

// NOTE: Draft + submit now use the same endpoint; the request must include `action: "draft" | "submit"`.

// ----------------------- API Above

function* getAllEventOverviewConfigurationListSaga(action: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(
        true
      )
    );
    let response: eventListAPIResponseType = yield call(
      getAllEventListOverview,
      action.payload.ID
    );
    const list = response.data ? response.data : [];
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventListData(list)
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(
        false
      )
    );
  } catch (e) {
    yield put(partnerProgramEventConfigurationSliceAction.setEventListData([]));
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(
        false
      )
    );
    console.log(e);
  }
}

function* getInsertEventOverviewConfigurationListSaga(action: {
  type: string;
  payload: {
    eventDeatils: any;
  };
}) {
  try {
    yield put(
      partnerProgramEventConfigurationSliceAction.setAddEventConfigurationLoading(
        true
      )
    );
    let response: eventListAPIResponseType = yield call(
      createEvent,
      action.payload.eventDeatils
    );

    yield put(
      partnerProgramEventConfigurationSliceAction.setAddEventConfigurationLoading(
        false
      )
    );
    yield put(getOverviewEventListing(response.data.partner_id));
  } catch (e) {
    //yield put(partnerProgramEventConfigurationSliceAction.setEventListData([]));
    yield put(
      partnerProgramEventConfigurationSliceAction.setAddEventConfigurationLoading(
        false
      )
    );
    console.log(e);
  }
}

function* getUpdateEventOverviewConfigurationListSaga(action: {
  type: string;
  payload: {
    eventDeatils: any;
  };
}) {
  try {
    yield put(
      partnerProgramEventConfigurationSliceAction.setAddEventConfigurationLoading(
        true
      )
    );
    let response: eventListAPIResponseType = yield call(
      updateEvent,
      action.payload.eventDeatils
    );

    yield put(
      partnerProgramEventConfigurationSliceAction.setAddEventConfigurationLoading(
        false
      )
    );
    yield put(getOverviewEventListing(response.data.partner_id));
  } catch (e) {
    //yield put(partnerProgramEventConfigurationSliceAction.setEventListData([]));
    yield put(
      partnerProgramEventConfigurationSliceAction.setAddEventConfigurationLoading(
        false
      )
    );
    console.log(e);
  }
}

function* getAllPartnerPointsConfigurationListSaga(action: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    // yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(true));
    let response: eventListAPIResponseType = yield call(
      fetchPartnerPointsAPI,
      action.payload.ID
    );
    const list = response.data ? response.data : [];
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventPointListData(list)
    );
    //yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(false));
  } catch (e) {
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventPointListData([])
    );
    //yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(false));
    console.log(e);
  }
}

function* getAllPartnerPointsSummaryConfigurationListSaga(action: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    // yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(true));
    let response: eventListAPIResponseType = yield call(
      getPartnerPointsSummaryFN,
      action.payload.ID
    );
    const list = response.data ? response.data : [];
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventPointSummaryListData(
        list
      )
    );
    //yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(false));
  } catch (e) {
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventPointSummaryListData(
        []
      )
    );
    //yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(false));
    console.log(e);
  }
}

function* getAllPartnerPointsDraftSummaryConfigurationListSaga(action: {
  type: string;
  payload: {
    ID: number;
  };
}) {
  try {
    // yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(true));
    let response: eventListAPIResponseType = yield call(
      getPartnerPointsDraftSummaryFN,
      action.payload.ID
    );
    const list = response.data ? response.data : [];
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventPointDraftSummaryListData(
        list
      )
    );
    //yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(false));
  } catch (e) {
    yield put(
      partnerProgramEventConfigurationSliceAction.setEventPointDraftSummaryListData(
        []
      )
    );
    //yield put(partnerProgramEventConfigurationSliceAction.setEventConfigurationLoading(false));
    console.log(e);
  }
}

function* submitEvaluationSaga(action: {
  type: string;
  payload: {
    eventDeatils: any;
  };
}) {
  try {
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationLoading(
        true
      )
    );
    let response: eventListAPIResponseType = yield call(
      submitPartnerPoints,
      action.payload.eventDeatils
    );

    let id = null;

    if (action.payload.eventDeatils instanceof FormData) {
      id = action.payload.eventDeatils.get("partner_id");
      console.log("id", id);
    } else {
      id = action.payload.eventDeatils.partner_id;
    }

    yield put(getPartnerPointsSummary(id));
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationLoading(
        false
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.evaluationSuccess(
        response.success
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationMessage(
        response.message
      )
    );
  } catch (e: any) {
    yield put(
      partnerProgramEventConfigurationSliceAction.evaluationSuccess(false)
    );
    //yield put(partnerProgramEventConfigurationSliceAction.setEventListData([]));
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationLoading(
        false
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationMessage(
        e.response?.data?.message
      )
    );
  }
}

function* saveToDraftEvaluationSaga(action: {
  type: string;
  payload: {
    eventDeatils: any;
  };
}) {
  try {
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationLoading(
        true
      )
    );
    let response: eventListAPIResponseType = yield call(
      submitPartnerPoints,
      action.payload.eventDeatils
    );

    let id = null;
    let assessment_date: string | undefined;
    let next_assessment_date: string | undefined;
    let comment: string | undefined;

    if (action.payload.eventDeatils instanceof FormData) {
      const fd = action.payload.eventDeatils;
      id = fd.get("partner_id") as unknown as number;
      assessment_date = (fd.get("assessment_date") as string) || undefined;
      next_assessment_date = (fd.get("next_assessment_date") as string) || undefined;
      const commentsStr = fd.get("comments") as string | null;
      if (commentsStr) {
        try {
          const comments = JSON.parse(commentsStr) as Array<{ comment?: string }>;
          comment = comments?.[0]?.comment;
        } catch {
          comment = undefined;
        }
      }
    } else {
      const payload = action.payload.eventDeatils;
      id = payload.partner_id;
      assessment_date = payload.assessment_date;
      next_assessment_date = payload.next_assessment_date;
      comment = payload.comments?.[0]?.comment;
    }
    if (id != null) {
      yield put(
        partnerProgramEventConfigurationSliceAction.setLastDraftFormFields({
          partnerId: Number(id),
          fields: { assessment_date, next_assessment_date, comment },
        })
      );
    }
    yield put(getPartnerPointsDraftSummary(id));
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationLoading(
        false
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.evaluationSuccess(
        response.success
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationMessage(
        response.message
      )
    );
  } catch (e: any) {
    yield put(
      partnerProgramEventConfigurationSliceAction.evaluationSuccess(false)
    );
    //yield put(partnerProgramEventConfigurationSliceAction.setEventListData([]));
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationLoading(
        false
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationMessage(
        e.response?.data?.message
      )
    );
  }
}

function* updatePartnerPointsSaga(action: {
  type: string;
  payload: {
    id: number;
    partnerId: number;
    body: FormData | Record<string, unknown>;
  };
}) {
  try {
    yield put(
      partnerProgramEventConfigurationSliceAction.setUpdatePartnerPointsLoading(
        true
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setPartnerPointsMutationMessage(
        ""
      )
    );
    const response: eventListAPIResponseType = yield call(
      updatePartnerPointsAPI,
      action.payload.id,
      action.payload.body
    );
    yield put(getPartnerPoints(action.payload.partnerId));
    yield put(
      partnerProgramEventConfigurationSliceAction.setUpdatePartnerPointsLoading(
        false
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setPartnerPointsMutationMessage(
        response?.message || "Updated successfully"
      )
    );
  } catch (e: any) {
    yield put(
      partnerProgramEventConfigurationSliceAction.setUpdatePartnerPointsLoading(
        false
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setPartnerPointsMutationMessage(
        e.response?.data?.message || "Update failed"
      )
    );
  }
}

function* deletePartnerPointsSaga(action: {
  type: string;
  payload: {
    assessmentId: number;
    partnerId: number;
  };
}) {
  try {
    yield put(
      partnerProgramEventConfigurationSliceAction.setDeletePartnerPointsLoading(
        true
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setPartnerPointsMutationMessage(
        ""
      )
    );
    yield call(deletePartnerPointsAPI, action.payload.assessmentId);
    yield put(getPartnerPoints(action.payload.partnerId));
    yield put(
      partnerProgramEventConfigurationSliceAction.setDeletePartnerPointsLoading(
        false
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setPartnerPointsMutationMessage(
        "Deleted successfully"
      )
    );
  } catch (e: any) {
    yield put(
      partnerProgramEventConfigurationSliceAction.setDeletePartnerPointsLoading(
        false
      )
    );
    yield put(
      partnerProgramEventConfigurationSliceAction.setPartnerPointsMutationMessage(
        e.response?.data?.message || "Delete failed"
      )
    );
  }
}

function* getFileUrlSaga(action: {
  type: string;
  payload: {
    fileName: any;
    type: any;
  };
}) {
  try {
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationLoading(
        true
      )
    );
    let response: eventListAPIResponseType = yield call(
      getFileUrlFn,
      action.payload.fileName,
      action.payload.type
    );

    if (response.success && response.url) {
      window.open(response.url, "_blank");
      // yield put(getPartnerPointsSummary(action.payload.eventDeatils.partner_id));
      yield put(
        partnerProgramEventConfigurationSliceAction.setFileDataUrl(response.url)
      );
    }
  } catch (e) {
    //yield put(partnerProgramEventConfigurationSliceAction.setEventListData([]));
    yield put(
      partnerProgramEventConfigurationSliceAction.setEvaluationConfigurationLoading(
        false
      )
    );
    console.log(e);
  }
}

function* partnerProgramEventConfigurationListSaga() {
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callEventListConfigurationSaga,
    getAllEventOverviewConfigurationListSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callAddEventListConfigurationSaga,
    getInsertEventOverviewConfigurationListSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callPointListConfigurationSaga,
    getAllPartnerPointsConfigurationListSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callPointSummaryListConfigurationSaga,
    getAllPartnerPointsSummaryConfigurationListSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callUpdateEventListConfigurationSaga,
    getUpdateEventOverviewConfigurationListSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callAddSubmitForEvalutionConfigurationSaga,
    submitEvaluationSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callDraftSubmitForEvalutionConfigurationSaga,
    saveToDraftEvaluationSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.getFileUrlSaga,
    getFileUrlSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callPointDraftSummaryListConfigurationSaga,
    getAllPartnerPointsDraftSummaryConfigurationListSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callUpdatePartnerPointsSaga,
    updatePartnerPointsSaga
  );
  yield takeLatest(
    partnerProgramEventSagaActionTypes.callDeletePartnerPointsSaga,
    deletePartnerPointsSaga
  );
}

export default partnerProgramEventConfigurationListSaga;
